import { DISMISS_ALERT } from "../constants";

export default () => ({
  type: DISMISS_ALERT,
});
